import { Injectable } from '@angular/core';

import { Yii } from "libraries/interfaces/Yii";

@Injectable()
export class BrowserClipboardService {
    public async copy(text: string): Promise<string> {
        // The real interface is Navigator, but clipboard is not declared
        // on it
        // tslint:disable-next-line: no-any
        const modernBrowser: any = navigator;

        if (!modernBrowser.clipboard) {
            return fallbackCopyTextToClipboard(text);
        }

        return modernBrowser.clipboard.writeText(text)
            .then(() => text)
            .catch((err: Error) => fallbackCopyTextToClipboard(text));
    }
}

async function fallbackCopyTextToClipboard(text: string): Promise<string> {
    const textArea: HTMLTextAreaElement = document.createElement("textarea");
    textArea.value = text;
    textArea.style.opacity = "0";
    textArea.style.width = "0";
    textArea.style.height = "0";
    textArea.style.position = "absolute";
    textArea.style.top = "0";
    textArea.style.left = "0";
    document.body.appendChild(textArea);
    // textArea.focus();
    textArea.select();

    try {
        const successful: boolean = document.execCommand('copy');

        if (successful) {
            return Promise.resolve(text);
        }

        return Promise.reject(new Error(Yii.t('wui-shared-js', "Impossible de copier dans le presse-papier")));
    } catch (err) {
        document.body.removeChild(textArea);
        return Promise.reject(new Error(Yii.t('wui-shared-js', "Impossible de copier dans le presse-papier")));
    } finally {
        document.body.removeChild(textArea);
    }
}